import { LaunchpadUser } from './types';

const testUserBaseInfo: Omit<
  LaunchpadUser,
  | 'id'
  | 'email'
  | 'name'
  | 'firstName'
  | 'lastName'
  | 'initials'
  | 'highbondId'
  | 'organization'
> = {
  password: 'asdQWE123',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
};

type GetLaunchpadUserParams = {
  userType?: LaunchpadUser['userType'];
  password?: LaunchpadUser['password'];
} & Pick<
  LaunchpadUser,
  | 'id'
  | 'email'
  | 'name'
  | 'highbondId'
  | 'organization'
  | 'secondaryOrganizations'
>;

export function getLaunchpadUser(
  params: GetLaunchpadUserParams,
): LaunchpadUser {
  const nameParts = params.name.trim().split(/\s+/);
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  // Generate initials:
  // first letter of firstName + first letter of lastName
  // (or second letter of firstName if no lastName)
  const initials = lastName
    ? (firstName.charAt(0) + lastName.charAt(0)).toUpperCase()
    : (firstName.charAt(0) + (firstName.charAt(1) || '')).toUpperCase();

  return {
    ...testUserBaseInfo,
    id: params.id,
    email: params.email,
    name: params.name,
    firstName,
    lastName,
    initials,
    highbondId: params.highbondId,
    organization: params.organization,
    secondaryOrganizations: params.secondaryOrganizations,
    userType: params.userType || testUserBaseInfo.userType,
    password: params.password || testUserBaseInfo.password,
  };
}

export function getLaunchpadUsers(
  params: GetLaunchpadUserParams[],
): LaunchpadUser[] {
  return params.map((param) => getLaunchpadUser(param));
}
